import { DatePicker, DatePickerProps } from "@mui/x-date-pickers/DatePicker";
import { Moment } from "moment";
import { useEffect, useRef, useState } from "react";
import Result from "../../utils/result.utils.ts";
import useDealBuilderAlertsStore from "../../../stores/deal-builder-alerts.store.ts";

interface BlurDatePickerProps extends DatePickerProps {
  isDateValid: (date: Moment) => Result<undefined>,
  onChange: (value: Moment) => void
}

export default function BlurDatePicker({
  isDateValid,
  ...props
}: BlurDatePickerProps) {
  const { setSnackMessage } = useDealBuilderAlertsStore();
  const [lastSetValue, setLastSetValue] = useState<Moment>(props.value.clone());
  const [inputValue, setInputValue] = useState<Moment>(props.value.clone());
  const pickerRef = useRef<HTMLInputElement | null>(null);
  const isInputValid = !inputValue ? { valid: false, error: "" } : isDateValid(inputValue);

  useEffect(() => {
    const propDate: Moment = props.value;
    if (!propDate.isSame(inputValue, "day")) {
      setInputValue(propDate);
    }
  }, [props.value]);

  function updateOrReset() {
    if (!inputValue || !inputValue.isValid()) return;
    if (isInputValid.valid) {
      setLastSetValue(inputValue.clone());
      props.onChange(inputValue.clone());
    } else {
      setInputValue(lastSetValue)
      if (isInputValid.error) {
        setSnackMessage(isInputValid.error);
      }
    }
  }

  return (
    <DatePicker
      {...props}
      ref={pickerRef}
      value={inputValue}
      onChange={(val) => {
        setInputValue(val);
      }}
      closeOnSelect={false}
      onClose={() => {
        updateOrReset();
      }}
      slotProps={{
        ...props.slotProps,
        textField: {
          ...props.slotProps?.textField,
          size: 'small',
          placeholder: 'MM/DD/YYYY',
          sx: {
            '& .MuiInputBase-root': {
              height: '40px'
            },
            ...(!isInputValid.valid && {
              '& fieldset': {
                border: "1px solid red !important"
              },
            }),
          },
          onBlur: (e: any) => {
            const isInsidePicker = pickerRef.current && pickerRef.current.contains(e.relatedTarget) && !(e.relatedTarget instanceof HTMLButtonElement);
            if (isInsidePicker) return;
            updateOrReset();
          }
        }
      }}
    />
  );
}
